//Library modul
import { Component } from "react";
import { connect } from "react-redux";

//Personal Component
import Login from "../../Components/auth/Login";
import NavigationLanding from "../../Components/layout/NavigationLanding";

//Redux function
import { openModal, setLanguage } from "../../App/actions/authActions";

//General Function
import dict from "../../Data/dict.json";
import LandingAuth from "../../Components/layout/LandingAuth";
import domain_list from "../../Data/domain_list";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

class LandingLogin extends Component {
  state = {
    width: window.innerWidth,
    loginStatus: true,
    specialist_code: "",

    bun_kai_connection: {
      status: null,
      message: "",
      code: "",
      is_loading: false
    },
    ws_int_kai_connection: {
      status: null,
      message: "",
      code: "",
      is_loading: false
    },
    ws_int_kai_via_bun_kai_connection: {
      status: null,
      message: "",
      code: "",
      is_loading: false
    }
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
    this.setState({ specialist_code: this?.props?.match?.params?.code });
    const isJoin = this?.props?.location?.pathname?.includes("join");
    this.setState({ loginStatus: !isJoin });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  onSetLanguage = (language) => {
    this.props.setLanguage(language);
  };

  onOpenModal = (name) => {
    this.props.openModal(name);
  };

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth }, () => { });
  };

  toggleLogin = () => {
    this.setState({ loginStatus: !this.state.loginStatus });
  };

  get_register_link = () => {
    const params = new URLSearchParams(window.location.search);
    const params_str = params.toString();
    let reg_link = "/register"
    if (params_str) reg_link = `/register?${params_str}`
    return reg_link;
  }

  render() {
    const language = localStorage?.language ? localStorage?.language : "ina";
    const domain = this.props.auth.domain;
    const domain_w_port = window.location.host;
    const is_login_kai = domain_list?.[domain_w_port]?.is_login_kai;

    let reg_link = this.get_register_link();

    const itemContent = (
      <div className="box_content">
        <div className="flex flex_col gap_10">
          <h1> {dict["Sign in"][language]}</h1>
          <p>
            {
              dict["Sign in to your account and enjoy the exclusive features."][
              language
              ]
            }
          </p>
        </div>
        <Login isNav={false} />
        {!is_login_kai && (
          <div className="box_content_bottom">
            <p className="button_account">
              {dict["Don't have an account?"][language]}
            </p>
            <Link
              to={reg_link}
              className="button_register text_black bold"
              data-mapid="clickRegister"
            >
              {dict["Sign up"][language]}
            </Link>
          </div>
        )}
      </div>
    );
    return (
      <LandingAuth
        nav={<NavigationLanding />}
        title={domain_list?.[domain]?.title}
        subtitle={domain_list?.[domain]?.sub_title}
        content={itemContent}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { openModal, setLanguage })(
  LandingLogin
);
